<template>
    <div class="col-md-12">
        <h2 class="mb-3"> {{ client.name }} </h2>
        <form @submit.prevent="updateClient">
            <div class="p-4 mb-0 bg-white rounded-lg">
                <div class="d-flex justify-content-between">
                    <div class="h4 mb-1">
                        General information
                    </div>
                    <div>
                        <a href="#" class="" @click="isEditing = !isEditing" v-if="!isEditing">
                            <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                        </a>
                        <a v-else-if="isEditing"> </a>
                        <a v-if="isEditing" @click="isEditing = false"></a>
                    </div>
                </div>

                <div class="">
                    <div class="container-fluid py-3">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="h-100 p-4 mb-0 bg-light rounded-lg">
                                    <div class="h5 mb-3">Address:</div>

                                    <div class="form-group">
                                        <div class="form-group">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing,  'border-danger': client.name=='' && isSubmit}">
                                                <input type="text" autocomplete="none" required
                                                       class="form-control  border-0 py-0 shadow-none form-input"
                                                       placeholder="Company name"
                                                       v-model="client.name" ref="name" :disabled="!isEditing"
                                                       :class="{view: !isEditing}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing,  'border-danger': client.billing_street=='' && isSubmit}">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Address"
                                                   v-model="client.billing_street" ref="billing_street"
                                                   :disabled="!isEditing" :class="{view: !isEditing}">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="form-group row">
                                            <div class="col-md-4">
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing,  'border-danger': client.billing_zip=='' && isSubmit}">
                                                    <input type="text" autocomplete="none" required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           placeholder="Zip code"
                                                           v-model="client.billing_zip" ref="billing_zip"
                                                           :disabled="!isEditing" :class="{view: !isEditing}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-8">
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing,  'border-danger': client.billing_city=='' && isSubmit}">
                                                    <input type="text" autocomplete="none" required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           placeholder="City"
                                                           v-model="client.billing_city" ref="billing_city"
                                                           :disabled="!isEditing" :class="{view: !isEditing}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div v-if="isEditing">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <select class="form-control border-0 py-0 shadow-none"
                                                        v-model="client.billing_country_id"
                                                        ref="billing_country_id">
                                                    <option value="1" selected>Denmark</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="h-100 p-4 mb-0 bg-light rounded-lg">
                                    <div class="h5 mb-3">Contact:</div>
                                    <div class="form-group">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing,  'border-danger': primaryContact.name=='' && isSubmit}">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Full name"
                                                   v-model="primaryContact.name" ref="contact.name"
                                                   :disabled="!isEditing"
                                                   :class="{view: !isEditing}">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing,  'border-danger': primaryContact.phone=='' && isSubmit}">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Phone"
                                                   v-model="primaryContact.phone" ref="contact.phone"
                                                   :disabled="!isEditing"
                                                   :class="{view: !isEditing}">

                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing,  'border-danger': primaryContact.email=='' && isSubmit}">
                                            <input type="email" autocomplete="none"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Email"
                                                   v-model="primaryContact.email" ref="contact.email"
                                                   :disabled="!isEditing"
                                                   :class="{view: !isEditing}">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="h-100 p-4 mb-0 bg-light rounded-lg">
                                    <div class="h5 mb-3">Other:</div>
                                    <div class="form-group">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing,  'border-danger': client.vat=='' && isSubmit}">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="VAT"
                                                   v-model="client.vat" ref="vat" :disabled="!isEditing"
                                                   :class="{view: !isEditing}">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing,  'border-danger': client.credit_days=='' && isSubmit}">
                                            <input type="number" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Credit days"
                                                   v-model="client.credit_days" ref="credit_days" :disabled="!isEditing"
                                                   :class="{view: !isEditing}">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing,  'border-danger': client.billing_email=='' && isSubmit}">
                                            <input type="email" autocomplete="none"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Invoice email"
                                                   v-model="client.billing_email" ref="billing_email"
                                                   :disabled="!isEditing"
                                                   :class="{view: !isEditing}">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <div class="row">
                            <div class="col-md-12 d-flex justify-content-center align-items-center mt-3">
                                <a @click="isEditing = !isEditing" v-if="!isEditing">
                                </a>
                                <button type="submit" class="btn btn-primary mr-2"
                                        v-else-if="isEditing" @click="validation()">
                                    Save
                                </button>
                                <a href="#" v-if="isEditing" @click="isEditing = false">Cancel</a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="text-muted"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="mt-3 p-4 mb-0 bg-white rounded-lg">
            <div class="h3 mb-3">Agreements</div>
            <div class="">
                <div class="container-fluid bg-light py-3">
                    <div class="controls">
                        <div class="row">
                            <div class="col-sm-1">
                                <strong class="h5 mb-3"> Name: </strong>
                            </div>
                            <div class="col-sm-4">
                                <strong class="h5 mb-3"> Default pickup address: </strong>
                            </div>

                            <div class="col-sm-4">
                                <strong class="h5 mb-3"> Default dropoff address: </strong>
                            </div>

                            <div class="col-sm-1">
                                <strong class="h5 mb-3"> Primary: </strong>
                            </div>
                            <div class="col-sm-1">

                            </div>
                            <div class="col-sm-1">

                            </div>
                        </div>
                    </div>
                </div>

                <div v-for="agreement in client.agreements" v-if="agreement.deleted_at===null">
                    <div class="container-fluid bg-light py-3">
                        <div class="controls">
                            <div class="row">
                                <div class="col-sm-1">
                                    {{ agreement.name }}
                                </div>

                                <div class="col-sm-4">
                                    {{ agreement.pickup_address.name }}
                                    {{ agreement.pickup_address.street }}
                                    {{ agreement.pickup_address.zip }}
                                    {{ agreement.pickup_address.city }}
                                    {{ agreement.pickup_address.country_id }}
                                </div>

                                <div class="col-sm-4">
                                    {{ agreement.dropoff_address.name }}
                                    {{ agreement.dropoff_address.street }}
                                    {{ agreement.dropoff_address.zip }}
                                    {{ agreement.dropoff_address.city }}
                                    {{ agreement.dropoff_address.country_id }}
                                </div>

                                <div class="col-sm-1">
                                    {{ agreement.primary_agreement === 1 ? 'Yes' : 'No' }}
                                </div>


                                <div class="col-sm-1">
                                    <div>
                                        <a :href="`/agreements/${agreement.id}/edit`" class="">
                                            <span
                                                class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-sm-1">
                                    <div
                                        @click="deleteAgreement(agreement.id)">
                                        <div
                                            class="material-icons-outlined cursor-pointer text-primary"
                                            title="delete agreement">delete
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <hr/>
                    </div>
                </div>

                <a :href="`/agreements/create/${client.id}`"
                   class="btn btn-success d-inline-flex align-items-center mt-5"
                   title="Create client">
                    <span class="material-icons-outlined cursor-pointer text-white mr-1">add_circle_outline</span><span>Create agreement</span>
                </a>
            </div>

        </div>

        <br/>
        <br/>


        <div class="mt-3 p-4 mb-0 bg-white rounded-lg">
            <div class="d-flex justify-content-between">
                <div class="h3 mb-3">Users</div>
                <div>
                    <a href="#" class="" @click="isEditingUser = !isEditingUser" v-if="!isEditingUser">
                        <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                    </a>
                    <a v-else-if="isEditingUser"> </a>
                    <a v-if="isEditingUser" @click="isEditingUser = false"></a>
                </div>
            </div>
            <div class="">
                <div class="container-fluid bg-light py-3">
                    <div class="controls">
                        <div class="row">
                            <div class="col-sm-3">
                                <strong class="h5 mb-3"> Name: </strong>
                            </div>
                            <div class="col-sm-3">
                                <strong class="h5 mb-3"> Email: </strong>
                            </div>
                            <div class="col-sm-2">
                                <strong class="h5 mb-3"> Password: </strong>
                            </div>
                            <div class="col-sm-2">
                                <strong class="h5 mb-3"> Agreement: </strong>
                            </div>
                            <div class="col-sm-2">
                                <strong class="h5 mb-3"> </strong>
                            </div>

                        </div>
                    </div>
                </div>
                <form @submit.prevent="updateUser">
                    <div class="row">
                        <div class="col-sm-12">
                            <div v-for="(errorArray, idx) in validationErrorsUpdateUser" :key="idx">
                                <div v-for="(allErrors, idx) in errorArray" :key="idx">
                                    <span class="text-danger">{{ allErrors }} </span> <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-for="(user, index) in client.users">
                        <div class="container-fluid bg-light py-3">
                            <div class="controls">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingUser,  'border-danger': client.users[index].name=='' && isSubmitUser}">
                                                <input type="text" required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder=""
                                                       v-model="client.users[index].name"
                                                       :disabled="!isEditingUser"
                                                       :class="{view: !isEditingUser}"
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-3">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingUser,  'border-danger': client.users[index].email=='' && isSubmitUser}">
                                            <input type="email" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   v-model="client.users[index].email"
                                                   :disabled="!isEditingUser"
                                                   :class="{view: !isEditingUser}"
                                            >
                                        </div>
                                    </div>

                                    <div class="col-sm-2">
                                        <div v-if="isEditingUser">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingUser,  'border-danger': client.users[index].password=='' && isSubmitUser}">
                                                <input type="password"
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="******"
                                                       v-model="client.users[index].password"
                                                       :class="{view: !isEditingUser}"
                                                >
                                            </div>
                                        </div>
                                        <div v-else>
                                            ******
                                        </div>
                                    </div>

                                    <div class="col-sm-2">
                                        <div v-if="isEditingUser">
                                            <div v-for="agreement in client.agreements">
                                                <input type="checkbox"
                                                       :value="agreement.id"
                                                       :checked="client.users[index].agreements!==null && client.users[index].agreements.includes(agreement.id)"
                                                       @change="onChangeUserAgreement($event,index)"
                                                >
                                                <label>
                                                    #{{ agreement.id }} - {{ agreement.name }}
                                                </label>
                                            </div>

                                            <!--                                            <div
                                                                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                                                            <select
                                                                                                required
                                                                                                class="form-control border-0 py-0 shadow-none"
                                                                                                v-model="client.users[index].agreement_id"
                                                                                            >
                                                                                                <option v-for="agreement in client.agreements"
                                                                                                        :value="agreement.id">
                                                                                                    {{ agreement.name }}
                                                                                                </option>
                                                                                            </select>
                                                                                        </div>-->

                                        </div>
                                        <div v-else>
                                            <!--                                            <div v-if="user.user_agreement">
                                                                                            #{{ user.user_agreement.id }} - {{ user.user_agreement.name }}
                                                                                        </div>-->
                                            <div v-for="agreement in client.agreements"
                                                 v-if="client.users[index].agreements!==null && client.users[index].agreements.includes(agreement.id)">
                                                #{{ agreement.id }} - {{ agreement.name }}
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div
                                            @click="deleteUser(user.id)">
                                            <div
                                                class="material-icons-outlined cursor-pointer text-primary"
                                                title="delete user">delete
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <hr/>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-center align-items-center mt-3">
                            <a @click="isEditingUser = !isEditingUser" v-if="!isEditingUser">
                            </a>
                            <button type="submit" class="btn btn-primary  mr-3"
                                    v-else-if="isEditingUser">
                                Update user data
                            </button>
                            <a href="#" v-if="isEditingUser" @click="isEditingUser = false">Cancel</a>
                        </div>
                    </div>
                    <br/>
                </form>
                <form @submit.prevent="saveNewUser">
                    <div v-if="showUserAddRow" class="container-fluid bg-light py-2">
                        <div class="row">
                            <div class="col-sm-12">
                                <div v-for="(errorArray, idx) in validationErrorsNewUser" :key="idx">
                                    <div v-for="(allErrors, idx) in errorArray" :key="idx">
                                        <span class="text-danger">{{ allErrors }} </span> <br/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <input type="text" required class="form-control" placeholder="User name"
                                           v-model="user.name">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <input type="email" required class="form-control" placeholder="email"
                                           v-model="user.email">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <input type="password" required class="form-control" placeholder="password"
                                           v-model="user.password">
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div v-for="agreement in client.agreements">
                                    <input type="checkbox"
                                           :id="`agreement_${agreement.id}`"
                                           v-model="user.agreements"
                                           :value="agreement.id"
                                    >
                                    <label :for="`agreement_${agreement.id}`"> {{ agreement.name }} </label>
                                </div>
                                <!--                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                                    <select required class="form-control border-0 py-0 shadow-none"
                                                                            v-model="user.agreementId">
                                                                        <option v-for="agreement in client.agreements" :value="agreement.id">
                                                                            {{ agreement.name }}
                                                                        </option>
                                                                    </select>
                                                                </div>-->
                            </div>

                            <div class="col-sm-1">

                            </div>

                        </div>
                        <div class="clearfix"></div>
                        <hr/>
                    </div>

                    <div v-if="!showUserAddRow">
                        <a v-on:click.prevent="showUserAddRow = true"
                           class="btn btn-success d-inline-flex align-items-center" title="Add user">
                            <span
                                class="material-icons-outlined cursor-pointer text-white mr-1">add_circle_outline</span>
                            <span>Add user</span>
                        </a>
                    </div>
                    <div v-else class="d-flex align-items-center mt-3">
                        <button type="submit" class="btn btn-primary mr-3" @click="validationUser()">
                            Save new user
                        </button>
                        <a href="#" @click="showUserAddRow = false">Cancel</a>
                    </div>

                </form>
            </div>
        </div>

        <br/>
        <br/>

        <div class="mt-3 p-4 mb-0 bg-white rounded-lg">
            <div class="d-flex justify-content-between">
                <div class="h3 mb-3">Contacts</div>
                <div>
                    <a href="#" class="" @click="isEditingContact = !isEditingContact" v-if="!isEditingContact">
                        <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                    </a>
                    <a v-else-if="isEditingContact"> </a>
                    <a v-if="isEditingContact" @click="isEditingContact = false"></a>
                </div>
            </div>
            <div class="">
                <div class="container-fluid bg-light py-3">
                    <div class="controls">
                        <div class="row">
                            <div class="col-sm-3">
                                <strong class="h5 mb-0"> Name: </strong>
                            </div>
                            <div class="col-sm-3">
                                <strong class="h5 mb-0"> Email: </strong>
                            </div>
                            <div class="col-sm-3">
                                <strong class="h5 mb-0"> Phone: </strong>
                            </div>
                            <div class="col-sm-3">
                                <strong class="h5 mb-0"> Comment: </strong>
                            </div>

                        </div>
                    </div>
                </div>
                <form @submit.prevent="updateContact">
                    <div class="row">
                        <div class="col-sm-12">
                            <div v-for="(errorArray, idx) in validationErrorsUpdateContact" :key="idx">
                                <div v-for="(allErrors, idx) in errorArray" :key="idx">
                                    <span class="text-danger">{{ allErrors }} </span> <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-for="(contact, index) in client.contacts">
                        <div class="container-fluid bg-light py-2">
                            <div class="controls">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingContact,  'border-danger': client.contacts[index].name=='' && isSubmitContact}">
                                                <input type="text" autocomplete="none" required
                                                       class="form-control  border-0 py-0 shadow-none form-input"
                                                       placeholder=""
                                                       v-model="client.contacts[index].name"
                                                       :disabled="!isEditingContact"
                                                       :class="{view: !isEditingContact}"
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-3">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingContact,  'border-danger': client.contacts[index].email=='' && isSubmitContact}">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control  border-0 py-0 shadow-none form-input"
                                                   v-model="client.contacts[index].email"
                                                   :disabled="!isEditingContact"
                                                   :class="{view: !isEditingContact}"
                                            >
                                        </div>
                                    </div>

                                    <div class="col-sm-3">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingContact,  'border-danger': client.contacts[index].phone=='' && isSubmitContact}">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control  border-0 py-0 shadow-none form-input"
                                                   v-model="client.contacts[index].phone"
                                                   :disabled="!isEditingContact"
                                                   :class="{view: !isEditingContact}"
                                            >
                                        </div>
                                    </div>

                                    <div class="col-sm-3">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingContact,  'border-danger': client.contacts[index].comment=='' && isSubmitContact}">
                                            <input type="text" autocomplete="none"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   v-model="client.contacts[index].comment"
                                                   :disabled="!isEditingContact"
                                                   :class="{view: !isEditingContact}"
                                            >
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <hr/>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-center align-items-center mt-3">
                            <a @click="isEditingContact = !isEditingContact" v-if="!isEditingContact">
                            </a>
                            <button type="submit" class="btn btn-primary mr-3"
                                    v-else-if="isEditingContact" @click="validationContact()">
                                Update contact data
                            </button>
                            <a href="#" v-if="isEditingContact" @click="isEditingContact = false">Cancel</a>
                        </div>
                    </div>
                    <br/>
                </form>
                <form @submit.prevent="saveNewContact">
                    <div v-if="showContactAddRow" class="container-fluid bg-light py-3">
                        <div class="row">
                            <div class="col-sm-12">
                                <div v-for="(errorArray, idx) in validationErrorsNewContact" :key="idx">
                                    <div v-for="(allErrors, idx) in errorArray" :key="idx">
                                        <span class="text-danger">{{ allErrors }} </span> <br/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <input type="text" autocomplete="none" required class="form-control"
                                           placeholder="Contact name"
                                           v-model="contact.name">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <input type="text" autocomplete="none" required class="form-control"
                                           placeholder="email"
                                           v-model="contact.email">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <input type="text" autocomplete="none" required class="form-control"
                                           placeholder="phone"
                                           v-model="contact.phone">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <input type="text" autocomplete="none" class="form-control"
                                           placeholder="comment"
                                           v-model="contact.comment">
                                </div>
                            </div>

                        </div>
                        <div class="clearfix"></div>
                        <hr/>
                    </div>

                    <div v-if="!showContactAddRow">
                        <a @click="showContactAddRow = true"
                           class="btn btn-success d-inline-flex align-items-center"
                           title="Add contact">
                            <span
                                class="material-icons-outlined cursor-pointer text-white mr-1">add_circle_outline</span>
                            <span>Add contact</span>
                        </a>
                    </div>
                    <div v-else>
                        <div class="d-flex align-items-center mt-3">
                            <button type="submit" class="btn btn-primary mr-3" @click="validation()">
                                Save new contact
                            </button>
                            <a href="#" @click="showContactAddRow = false">Cancel</a>
                        </div>

                    </div>

                </form>
            </div>
        </div>


        <br/>
        <br/>

        <div class="mt-3 p-4 mb-0 bg-white rounded-lg">
            <div class="d-flex justify-content-between">
                <div class="h3 mb-3">API keys</div>
                <div>
                    <a href="#" class="" @click="isEditingApi = !isEditingApi" v-if="!isEditingApi">
                        <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                    </a>
                    <a v-if="isEditingApi" @click="isEditingApi = false"></a>
                </div>
            </div>
            <div class="">
                <div class="container-fluid bg-light py-3">
                    <div class="controls">
                        <div class="row">
                            <div class="col-sm-3">
                                <strong class="h5 mb-3"> Name: </strong>
                            </div>
                            <div class="col-sm-3">
                                <strong class="h5 mb-3"> Key: </strong>
                            </div>
                            <div class="col-sm-2">
                                <strong class="h5 mb-3"> </strong>
                            </div>

                        </div>
                    </div>
                </div>
                <form @submit.prevent="updateApi">
                    <div v-for="(api,index) in client.keys">
                        <div class="container-fluid bg-light py-3">
                            <div class="controls">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <input type="text" autocomplete="none"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   v-model="client.keys[index].name"
                                                   :disabled="!isEditingApi"
                                                   :class="{view: !isEditingApi}"
                                            >
                                        </div>
                                    </div>

                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <input type="text" autocomplete="none"
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   v-model="client.keys[index].key"
                                                   :disabled="!isEditingApi"
                                                   :class="{view: !isEditingApi}"
                                            >
                                        </div>
                                    </div>

                                    <div class="col-sm-2">
                                        <div
                                            @click="deleteApi(client.keys[index].id)">
                                            <div
                                                class="material-icons-outlined cursor-pointer text-primary"
                                                title="delete api key">delete
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <hr/>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-center align-items-center mt-3">
                            <a @click="isEditingApi = !isEditingApi" v-if="!isEditingApi">
                            </a>
                            <button type="submit" class="btn btn-primary mr-3"
                                    v-else-if="isEditingApi" @click="validationApi()">
                                Update api keys
                            </button>
                            <a href="#" v-if="isEditingApi" @click="isEditingApi = false">Cancel</a>
                        </div>
                    </div>
                    <br/>
                </form>
                <br/>
                <form @submit.prevent="saveNewApi">
                    <div v-if="showApiAddRow" class="container-fluid bg-light py-2">
                        <div class="row">
                            <div class="col-sm-12">
                                <div v-for="(errorArray, idx) in validationErrorsNewApi" :key="idx">
                                    <div v-for="(allErrors, idx) in errorArray" :key="idx">
                                        <span class="text-danger">{{ allErrors }} </span> <br/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">

                                    <input type="text" required class="form-control" placeholder="name"
                                           v-model="api.name">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <input type="text" required class="form-control" placeholder="key"
                                           v-model="api.key">
                                </div>
                            </div>

                            <div class="col-sm-1">

                            </div>

                        </div>
                        <div class="clearfix"></div>
                        <hr/>
                    </div>
                    <br/>
                    <div v-if="!showApiAddRow">
                        <a v-on:click.prevent="showApiAddRow = true"
                           class="btn btn-success d-inline-flex align-items-center" title="Add api key">
                            <span
                                class="material-icons-outlined cursor-pointer text-white mr-1">add_circle_outline</span>
                            <span>Add api key</span>
                        </a>
                    </div>

                    <div v-else class="d-flex align-items-center mt-3">
                        <button type="submit" class="btn btn-primary mr-3" @click="validationApi()">
                            Save
                        </button>
                        <a href="#" @click="showApiAddRow = false">Cancel</a>
                    </div>
                </form>
            </div>
        </div>

        <br/>
        <br/>

        <data-sources
            v-if="client.id"
            :data-sources-prop="dataSources"
            :available-data-sources="availableDataSources"
            :clientId="client.id"
            :available-products="client.agreement ? client.agreement.products : []"
            :all-available-agreements="client.agreements ? client.agreements : []"
            :available-services="client.agreement ? client.agreement.services: []"
            :booking-types="bookingTypes"
            :booking-type-mapping-keys="bookingTypeMappingKeys"
        ></data-sources>


        <a href="/clients" title="Back" class="text-decoration-none d-block mt-3">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>

    </div>
</template>

<script>

import DataSources from "./reusable/DataSources.vue";
export default {
    name: "ClientEdit",
    props: {
        url: {type: String, required: true},
        availableDataSources: {type: Array, required: true},
        bookingTypes: {type: Object, required: true},
        bookingTypeMappingKeys: {type: Array, required: true}
    },
    components: {DataSources},
    data() {
        return {
            isEditing: false,
            isEditingAgreement: false,
            isEditingUser: false,
            isEditingContact: false,
            isEditingApi: false,
            isEditingDataSources: false,
            showUserAddRow: false,
            showApiAddRow: false,
            showContactAddRow: false,
            client: {},
            primaryContact: {},
            agreement: {},
            user: {
                'agreements': []
            },
            contact: {},
            api: {},
            validationErrorsNewUser: '',
            validationErrorsUpdateUser: '',
            validationErrorsNewContact: '',
            validationErrorsUpdateContact: '',
            validationErrorsNewApi: '',
            isSubmit: false,
            isSubmitUser: false,
            isSubmitContact: false,
            dataSources: []
        }
    },
    methods: {
        updateClient() {
            axios.patch(`/clients/${this.client.id}`, this.client).then((response) => {
                this.isEditing = !this.isEditing;
                window.location.href = `/clients/${response.data.clientId}/edit`;
            }).catch(err => console.log(err))
        },
        validationUser() {
            this.isSubmit = true;
        },
        validationApi() {
            this.isSubmit = true;
        },
        validationContact() {
            this.isSubmit = true;
        },
        validation() {
            this.isSubmit = true;
        },
        updateUser() {
            axios.patch(`/users`, this.client.users).then((response) => {
                window.location.reload();
            }).catch(e => {
                this.validationErrorsUpdateUser = e.response.data.errors
            })
        },
        updateContact() {
            axios.patch(`/contacts`, this.client.contacts).then((response) => {
                window.location.reload();
            }).catch(e => {
                this.validationErrorsUpdateContact = e.response.data.errors
            })
        },
        updateApi() {
            axios.patch(`/client/update-api-key`, this.client.keys).then((response) => {
                window.location.reload();
            }).catch(e => {
                this.validationErrorsUpdateContact = e.response.data.errors
            })
        },
        fetchData() {
            let dataFetchUrl = `${this.url}`
            axios.get(dataFetchUrl)
                .then(({data}) => {
                    this.client = data;
                    this.primaryContact = this.client.primary_contact;
                    this.dataSources = this.client.data_sources;
                }).catch(error => this.client = [])
        },
        saveNewUser() {
            this.user.clientId = this.client.id;
            axios.post('/users', this.user).then((response) => {
                window.location.href = `/clients/${this.client.id}/edit`;
            }).catch(e => {
                this.validationErrorsNewUser = e.response.data.errors
            })
        },
        saveNewApi() {
            this.api.clientId = this.client.id;
            axios.post('/client/store-api-key', this.api).then((response) => {
                window.location.href = `/clients/${this.client.id}/edit`;
            }).catch(e => {
                this.validationErrorsNewApi = e.response.data.errors
            })
        },
        saveNewContact() {
            this.contact.clientId = this.client.id;
            axios.post('/contacts', this.contact).then((response) => {
                window.location.href = `/clients/${this.client.id}/edit`;
            }).catch(e => {
                this.validationErrorsNewContact = e.response.data.errors
            })
        },
        deleteUser(value) {
            if (confirm("Are you sure you want to delete this user?")) {
                axios.delete(`/users/${value}`).then((response) => {
                    window.location.reload();
                }).catch(err => console.log(err))
            }
        },
        deleteAgreement(value) {
            if (confirm("Are you sure you want to delete this agreement?")) {
                axios.delete(`/agreements/${value}`).then((response) => {
                    window.location.reload();
                }).catch(err => console.log(err))
            }
        },
        deleteApi(id) {
            axios.delete(`/client/delete-api-key/${id}`).then((response) => {
                window.location.reload();
            }).catch(err => console.log(err))
        },
        onChangeUserAgreement(event, userIndex) {
            let value = parseInt(event.target.value);
            let agreementsArray;
            if (typeof (this.client.users[userIndex].agreements) === 'string') {
                agreementsArray = JSON.parse(this.client.users[userIndex].agreements);
            } else {
                agreementsArray = this.client.users[userIndex].agreements;
            }
            // console.log(agreementsArray);
            if (agreementsArray !== null) {
                if (agreementsArray.includes(value)) {
                    let index = agreementsArray.indexOf(value);
                    if (index > -1) {
                        agreementsArray.splice(index, 1);
                    }
                } else {
                    agreementsArray.push(value)
                }
            } else {
                agreementsArray = [];
                agreementsArray.push(value);
            }
            this.client.users[userIndex].agreements = agreementsArray
        },
    },
    created() {
        return this.fetchData()
    },
}

</script>
